module.exports = __webpack_public_path__ + "static/media/ic-contrato-faturacao.55931140.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Filters/images/ic-contrato-faturacao.svg
// module id = 1084
// module chunks = 0